import {
  Component,
  Output,
  EventEmitter,
  ViewEncapsulation,
} from '@angular/core';
import { AppSettings } from 'src/app/app.config';
import { CoreService } from 'src/app/services/core.service';
import { BrandingComponent } from '../../vertical/sidebar/branding.component';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { NgIf } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { NgScrollbarModule } from 'ngx-scrollbar';
import { UserService } from 'src/app/services/user.service';
import { User } from 'src/app/models/user.model';
import { AppearancePreferencesComponent } from 'src/app/components/appearance-preferences/appearance-preferences.component';

export interface AppearanceOptions {
  activeTheme: string,
  boxed: boolean,
  cardBorder: boolean,
  dir: 'ltr' | 'rtl',
  horizontal: boolean,
  language: string,
  navPos: 'side' | 'top',
  sidenavCollapsed: boolean,
  sidenavOpened: boolean,
  theme: string,
  logo?: string,
  title?: string
}

@Component({
  selector: 'app-customizer',
  standalone: true,
  imports: [BrandingComponent, TablerIconsModule, MaterialModule, FormsModule, NgScrollbarModule, NgIf, AppearancePreferencesComponent],
  templateUrl: './customizer.component.html',
  styleUrls: ['./customizer.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CustomizerComponent {

  user: User

  @Output() optionsChange = new EventEmitter<AppSettings>();
  constructor(
    private settings: CoreService,
    private userService: UserService
  ) {

    this.user = this.userService.user;
  }

  options: AppearanceOptions = this.settings.getOptions();

  updateAppearance() {
    console.log("Options in updateAppearance: ", this.options);
    this.user.appearance = { ...this.user.appearance, ...this.options };
    this.optionsChange.emit(this.options);

    let DTO = {
      text: this.user.appearance.title,
      ...this.user.appearance
    };

    // Eliminar la propiedad favicon del objeto DTO
    delete DTO.favicon;

    this.userService.updateAppearance(DTO).subscribe({
      next: (res) => {
        console.log("Updated appearance: ", res)
        // Guardar la configuración de apariencia en localStorage
        localStorage.setItem('userAppearance', JSON.stringify(this.options));
        this.settings.setOptions(this.options);
      },
      error: (err) => {
        console.error("Error updating appearance: ", err)
      }
    })
  }

}
